import { TooltipProviderPrimitive, TooltipRootPrimitive } from "../../primitives";
import type { TooltipProps } from "./types";

/**
 * Tooltip root.
 *
 * Short text about a trigger, shown on hover and keyboard focus (web) or long
 * press (native). A browser Tooltip has no touch path, so anything a touch user
 * must read, and anything interactive, goes in a Popover (J6).
 *
 * Wraps the trigger and content in a Radix/RNR tooltip primitive and includes
 * its own provider so the molecule works standalone. On web Radix reads the
 * nearest provider, which is always this one: an app-level provider's
 * `skipDelayDuration` or `disableHoverableContent` doesn't reach it, so each
 * Tooltip waits its own `delayDuration`.
 */
export const Tooltip = ({
  open,
  defaultOpen,
  onOpenChange,
  delayDuration = 200,
  children,
}: TooltipProps) => (
  <TooltipProviderPrimitive delayDuration={delayDuration}>
    <TooltipRootPrimitive
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      delayDuration={delayDuration}
    >
      {children}
    </TooltipRootPrimitive>
  </TooltipProviderPrimitive>
);

Tooltip.displayName = "Tooltip";
